export default __webpack_public_path__ + "static/media/subscription_task.a775bba0.svg";